import RecordLogo from '../../Icons/record-logo.svg';
import Grid from '@mui/material/Grid';
import MyLabel from './MyLabel';
import PaperStyled from '../../PaperStyled';
import StyledRecordDuration from './StyledRecordDuration';

const RecordDuration = ({
  id,
  days,
  setDays,
  hours,
  setHours,
  minutes,
  setMinutes,
  mode,
  setMode,
  availableModesOptions,
  setAvailableModesOptions,
  isStorageCalculatorActive
}) => {
  return (
    <Grid item md={5} xs={12} style={{ display: 'flex', justifyContent: 'center' }}>
      <PaperStyled>
        <MyLabel logo={RecordLogo} label="Record Duration" marginLeft="2.5em" />
        <StyledRecordDuration
          id={id}
          time={{ days: days, hours: hours, minutes: minutes }}
          mode={mode}
          setMode={setMode}
          availableModesOptions={availableModesOptions}
          setAvailableModesOptions={setAvailableModesOptions}
          isDisabled={isStorageCalculatorActive ? false : true}
          setTimeDays={setDays}
          setTimeHours={setHours}
          setTimeMinutes={setMinutes}
        />
      </PaperStyled>
    </Grid>
  );
};

export default RecordDuration;
